import axios from '@/utils/api';

const getUsers = (
  params,
) => axios.get('admin/users', { params });

const deleteUser = (
  id,
) => axios.delete(`/admin/users/${id}`);

/* eslint-disable */
export {
  getUsers,
  deleteUser,
};
